import { f as __generator } from '../../../../tslib.es6-fe064bda.js';
import { SoundType } from './types.js';

var _a;
var defaultSounds = (_a = {},
    _a[SoundType.Music] = {
        name: SoundType.Music,
        src: 'music.mp3',
        autoplay: false,
        html5: true,
        loop: false,
    },
    _a[SoundType.Win] = {
        name: SoundType.Win,
        src: 'sounds/en/you_won.mp3',
        autoplay: false,
        html5: true,
        getSrc: function (lang) { return "sounds/".concat(lang, "/you_won.mp3"); },
        loop: false,
    },
    _a[SoundType.BetAccepted] = {
        name: SoundType.BetAccepted,
        src: 'sounds/en/your_bet_is_accepted.mp3',
        autoplay: false,
        html5: true,
        getSrc: function (lang) { return "sounds/".concat(lang, "/your_bet_is_accepted.mp3"); },
        loop: false,
    },
    _a[Symbol.iterator] = function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, this[SoundType.Music]];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, this[SoundType.Win]];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, this[SoundType.BetAccepted]];
                case 3:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    },
    _a);

export { defaultSounds };
